import { ConfigDataInterface } from './ConfigApiInterface';

export enum Config_RegulationCreate_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_RegulationCreate_Modules_ApiEnum {
    'form' = 'form',
}

export enum Config_RegulationCreate_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_RegulationCreate_PageMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_RegulationCreate_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_RegulationCreate_ApiInterface
    extends ConfigDataInterface<
        Config_RegulationCreate_Modules_ApiEnum,
        Config_RegulationCreate_ActionsMenu_ApiEnum,
        Config_RegulationCreate_ActionsOther_ApiEnum,
        Config_RegulationCreate_PageMenu_ApiEnum,
        Config_RegulationCreate_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
